import {IWinnerTicket, IWish, WishStatus} from "../store/wish/Helper";

export const getResolvedWinners = (
    wish: IWish | undefined,
    fetchedWinners: IWinnerTicket[] | null | undefined
): IWinnerTicket[] => {
    return fetchedWinners?.length ? fetchedWinners : (wish?.winners ?? []);
};

export const hasCompleteWinners = (
    wish: IWish | undefined,
    fetchedWinners: IWinnerTicket[] | null | undefined
): boolean => {
    const winners = getResolvedWinners(wish, fetchedWinners);
    const expectedWinners = Number(wish?.number_of_winners ?? 0);
    const hasExpectedWinnerCount = expectedWinners > 0
        ? winners.length >= expectedWinners
        : winners.length > 0;

    return wish?.status === WishStatus.FINISHED && hasExpectedWinnerCount;
};
